module.exports = __webpack_public_path__ + "img/huace20.1f480da2.jpg";